import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordComponent } from './authentification/components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './authentification/components/reset-password/reset-password.component';
import { SignInComponent } from './authentification/components/sign-in/sign-in.component';
import { SignOutComponent } from './authentification/components/sign-out/sign-out.component';
import { AddCollabComponent } from './utilisateur/components/add-collab/add-collab.component';
import { FormValidationComponent } from './utilisateur/components/validate-collab/form-validation/form-validation.component';
import { ValidateCollabComponent } from './utilisateur/components/validate-collab/validate-collab.component';
import { LOCALE_ID } from '@angular/core';
import { AdminLayout } from '@perval/admin';
import { OauthCallbackComponent } from './authentification/components/oauth-callback/oauth-callback.component';
import { SignInErrorsComponent } from './authentification/components/sign-in/sign-in-errors/sign-in-errors.component';
import { ChoixPackComponent } from './credit/components/commande-choix-pack/choix-pack.component';
import { PackComponent } from './credit/components/commande-choix-pack/pack/pack.component';
import { CommandeHeaderComponent } from './credit/components/commande-header/commande-header.component';
import { InformationsAdministrativesComponent } from './credit/components/commande-informations-administratives/commande-informations-administratives.component';
import { InformationsAdministrativesFormComponent } from './credit/components/commande-informations-administratives/informations-administratives-form/informations-administratives-form.component';
import { MonPanierComponent } from './credit/components/commande-informations-administratives/mon-panier/mon-panier.component';
import { CommandeValidationComponent } from './credit/components/commande-validation/commande-validation.component';
import { GrilleAchatServicesComponent } from './credit/components/grille-achat-services/grille-achat-services.component';
import { InformationsCommandeMessagesComponent } from './credit/components/informations-commande-messages/informations-commande-messages.component';
import { CommandeCreditsOnlineContainer } from './credit/pages/commander-credits-online/commande-credits-online.container';
import { CommandeCreditsContainer } from './credit/pages/commander-credits/commande-credits.container';
import { HistoriqueServicesTableComponent } from './historique-services/components/historique-services-table/historique-services-table.component';
import { SearchFormComponent } from './historique-services/components/search-form/search-form.component';
import { HistoriqueServicesContainer } from './historique-services/pages/historique-services.container';
import { BienComparablesVendusEditModeComponent } from './rapport/components/biens-comparables-vendus/biens-comparables-vendus-edit-mode/biens-comparables-vendus-edit-mode.component';
import { BiensComparablesVendusReadModeComponent } from './rapport/components/biens-comparables-vendus/biens-comparables-vendus-read-mode/biens-comparables-vendus-read-mode.component';
import { BiensComparablesVendusComponent } from './rapport/components/biens-comparables-vendus/biens-comparables-vendus.component';
import { CadastreEditModeComponent } from './rapport/components/cadastre/cadastre-edit-mode/cadastre-edit-mode.component';
import { CadastreReadModeComponent } from './rapport/components/cadastre/cadastre-read-mode/cadastre-read-mode.component';
import { CadastreComponent } from './rapport/components/cadastre/cadastre.component';
import { AppartementFormComponent } from './rapport/components/caracteristiques/caracteristiques-edit-mode/appartement-form/appartement-form.component';
import { BienAgricoleFormComponent } from './rapport/components/caracteristiques/caracteristiques-edit-mode/bien-agricole-form/bien-agricole-form.component';
import { BienViticoleFormComponent } from './rapport/components/caracteristiques/caracteristiques-edit-mode/bien-viticole-form/bien-viticole-form.component';
import { CaracteristiquesEditModeComponent } from './rapport/components/caracteristiques/caracteristiques-edit-mode/caracteristiques-edit-mode.component';
import { GarageFormComponent } from './rapport/components/caracteristiques/caracteristiques-edit-mode/garage-form/garage-form.component';
import { ImmeubleFormComponent } from './rapport/components/caracteristiques/caracteristiques-edit-mode/immeuble-form/immeuble-form.component';
import { LocalActiviteFormComponent } from './rapport/components/caracteristiques/caracteristiques-edit-mode/local-activite-form/local-activite-form.component';
import { MaisonFormComponent } from './rapport/components/caracteristiques/caracteristiques-edit-mode/maison-form/maison-form.component';
import { TerrainFormComponent } from './rapport/components/caracteristiques/caracteristiques-edit-mode/terrain-form/terrain-form.component';
import { CaracteristiqueComponent } from './rapport/components/caracteristiques/caracteristiques-read-mode/caracteristique/caracteristique.component';
import { CaracteristiquesReadModeComponent } from './rapport/components/caracteristiques/caracteristiques-read-mode/caracteristiques-read-mode.component';
import { CaracteristiquesComponent } from './rapport/components/caracteristiques/caracteristiques.component';
import { CartographieComponent } from './rapport/components/cartographie/cartographie.component';
import { DetailsDossierEditModeComponent } from './rapport/components/details-dossier/details-dossier-edit-mode/details-dossier-edit-mode.component';
import { DetailsDossierReadModeComponent } from './rapport/components/details-dossier/details-dossier-read-mode/details-dossier-read-mode.component';
import { DetailsDossierComponent } from './rapport/components/details-dossier/details-dossier.component';
import { ExpertImmobilierEditModeComponent } from './rapport/components/expert-immobilier/expert-immobilier-edit-mode/expert-immobilier-edit-mode.component';
import { ExpertImmobilierReadModeComponent } from './rapport/components/expert-immobilier/expert-immobilier-read-mode/expert-immobilier-read-mode.component';
import { ExpertImmobilierComponent } from './rapport/components/expert-immobilier/expert-immobilier.component';
import { InformationsBienEditModeComponent } from './rapport/components/informations-bien/informations-bien-edit-mode/informations-bien-edit-mode.component';
import { InformationsBienReadModeComponent } from './rapport/components/informations-bien/informations-bien-read-mode/informations-bien-read-mode.component';
import { InformationsBienComponent } from './rapport/components/informations-bien/informations-bien.component';
import { InformationsClientEditModeComponent } from './rapport/components/informations-client/informations-client-edit-mode/informations-client-edit-mode.component';
import { InformationsClientReadModeComponent } from './rapport/components/informations-client/informations-client-read-mode/informations-client-read-mode.component';
import { InformationsClientComponent } from './rapport/components/informations-client/informations-client.component';
import { InformationsGeneralesComponent } from './rapport/components/informations-generales/informations-generales.component';
import { LesPlusComponent } from './rapport/components/les-plus/les-plus.component';
import { NotreOrganismeEditModeComponent } from './rapport/components/notre-organisme/notre-organisme-edit-mode/notre-organisme-edit-mode.component';
import { NotreOrganismeReadModeComponent } from './rapport/components/notre-organisme/notre-organisme-read-mode/notre-organisme-read-mode.component';
import { NotreOrganismeComponent } from './rapport/components/notre-organisme/notre-organisme.component';
import { PhotographiesEditModeComponent } from './rapport/components/photographies/photographies-edit-mode/photographies-edit-mode.component';
import { PhotographiesReadModeComponent } from './rapport/components/photographies/photographies-read-mode/photographies-read-mode.component';
import { PhotographiesComponent } from './rapport/components/photographies/photographies.component';
import { SectionComponent } from './rapport/components/section/section.component';
import { TendanceMarcheImmobilierComponent } from './rapport/components/tendance-marche-immobilier/tendance-marche-immobilier.component';
import { TendanceMarcheImmobilierEditModeComponent } from './rapport/components/tendance-marche-immobilier/tendance-marche-immobilier-edit-mode/tendance-marche-immobilier-edit-mode.component';
import { TendanceMarcheImmobilierReadModeComponent } from './rapport/components/tendance-marche-immobilier/tendance-marche-immobilier-read-mode/tendance-marche-immobilier-read-mode.component';
import { VotreEstimationEditModeComponent } from './rapport/components/votre-estimation/votre-estimation-edit-mode/votre-estimation-edit-mode.component';
import { PlusOuMoinsValuesComponent } from './rapport/components/votre-estimation/votre-estimation-read-mode/plus-ou-moins-values/plus-ou-moins-values.component';
import { ValeurEstimeeAvecPlusOuMoinsValuesComponent } from './rapport/components/votre-estimation/votre-estimation-read-mode/valeur-estimee-avec-plus-ou-moins-values/valeur-estimee-avec-plus-ou-moins-values.component';
import { ValeurEstimeeSansPlusOuMoinsValuesComponent } from './rapport/components/votre-estimation/votre-estimation-read-mode/valeur-estimee-sans-plus-ou-moins-values/valeur-estimee-sans-plus-ou-moins-values.component';
import { ValeurRetenueComponent } from './rapport/components/votre-estimation/votre-estimation-read-mode/valeur-retenue/valeur-retenue.component';
import { VotreEstimationReadModeComponent } from './rapport/components/votre-estimation/votre-estimation-read-mode/votre-estimation-read-mode.component';
import { VotreEstimationComponent } from './rapport/components/votre-estimation/votre-estimation.component';
import { RapportContainer } from './rapport/pages/rapport.container';
import {
  FailComponent,
  PageNotFoundComponent,
  SuccessComponent,
} from './shared';
import { DesignSystemModule } from './shared/design-system/design-system.module';
import { ContainerComponent } from './shared/layouts/container/container.component';
import { NcPipe } from './shared/pipes/nc.pipe';
import { SquareMeterPipe } from './shared/pipes/square-meter.pipe';
import { TrimPipe } from './shared/pipes/trim.pipe';
import { HelpSearchComponent } from './static/pages/help-search/help-search.component';
import { LegalNoticesComponent } from './static/pages/legal-notices/legal-notices.component';
import { StatsActionsComponent } from './statistics/components/stats-actions/stats-actions.component';
import { StatsImage } from './statistics/components/stats-image/stats-image.component';
import { PreContractStats } from './statistics/pages/pre-contract-stats/pre-contract-stats.component';
import { InfoComponent } from './technique/components/info/info.component';
import { ProfileFormComponent } from './utilisateur/components/profile-form/profile-form.component';
import { FormResetComponent } from './utilisateur/components/validate-collab/form-reset/form-reset.component';
import { CollaboraterProfileComponent } from './utilisateur/pages/collaborater-profile/collaborater-profile.component';
import { MyProfileComponent } from './utilisateur/pages/my-profile/my-profile.component';
import { AddressEditModeComponent } from './rapport/components/address/address-edit-mode/address-edit-mode.component';
import { AddressComponent } from './rapport/components/address/address.component';
import { AddressReadModeComponent } from './rapport/components/address/address-read-mode/address-read-mode.component';
import { ArrayFieldGetterPipe } from './shared/pipes/array-field-getter.pipe';
import { StatistiquesComponent } from './rapport/components/statistiques/statistiques.component';
import { LandingPageComponent } from './landing-page/pages/landing-page.component';
import { HeaderComponent } from './landing-page/components/header/header.component';
import { HeroSectionComponent } from './landing-page/components/hero-section/hero-section.component';
import { HeroSectionBoxComponent } from './landing-page/components/hero-section-box/hero-section-box.component';
import { DescriptionSectionComponent } from './landing-page/components/description-section/description-section.component';
import { ServicesSectionComponent } from './landing-page/components/services-section/services-section.component';
import { CardComponent } from './landing-page/components/card/card.component';
import { KeyFiguresComponent } from './landing-page/components/key-figures/key-figures.component';
import { ToolsSectionComponent } from './landing-page/components/tools-section/tools-section.component';
import { FooterComponent } from './landing-page/components/footer/footer.component';
import { ContactSectionComponent } from './landing-page/components/contact-section/contact-section.component';
import { BurgerMenuComponent } from './landing-page/components/burger-menu/burger-menu.component';
import { PrivacyPolicyComponent } from './landing-page/components/privacy-policy/privacy-policy.component';
import { SafePipe } from './shared/pipes/safe.pipe';
import { NotesComponent } from './rapport/components/notes/notes.component';
import { NotesReadModeComponent } from './rapport/components/notes/notes-read-mode/notes-read-mode.component';
import { NotesEditModeComponent } from './rapport/components/notes/notes-edit-mode/notes-edit-mode.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CropperjsPictureEditorComponent } from '@perval/cropperjs-picture-editor';
import { FeatureFlagDirective } from './shared/directives/feature-flag.directive';
import { LesMoinsComponent } from './rapport/components/les-moins/les-moins.component';
import { DefinitionsComponent } from './rapport/components/definitions/definitions.component';

const DECLARED = [
  SignInComponent,
  SignInErrorsComponent,
  SignOutComponent,
  OauthCallbackComponent,
  AddCollabComponent,
  ContainerComponent,
  FailComponent,
  ForgotPasswordComponent,
  ResetPasswordComponent,
  ValidateCollabComponent,
  FormValidationComponent,
  SuccessComponent,
  PageNotFoundComponent,
  InfoComponent,
  FormResetComponent,
  ChoixPackComponent,
  PackComponent,
  CommandeCreditsOnlineContainer,
  CommandeHeaderComponent,
  InformationsAdministrativesComponent,
  InformationsAdministrativesFormComponent,
  MonPanierComponent,
  CommandeValidationComponent,
  CommandeCreditsContainer,
  GrilleAchatServicesComponent,
  ProfileFormComponent,
  MyProfileComponent,
  CollaboraterProfileComponent,
  HistoriqueServicesContainer,
  HistoriqueServicesTableComponent,
  TrimPipe,
  NcPipe,
  SquareMeterPipe,
  InformationsCommandeMessagesComponent,
  SearchFormComponent,
  RapportContainer,
  VotreEstimationComponent,
  PlusOuMoinsValuesComponent,
  ValeurEstimeeAvecPlusOuMoinsValuesComponent,
  ValeurRetenueComponent,
  VotreEstimationReadModeComponent,
  VotreEstimationEditModeComponent,
  BiensComparablesVendusComponent,
  BienComparablesVendusEditModeComponent,
  BiensComparablesVendusReadModeComponent,
  InformationsClientComponent,
  InformationsClientReadModeComponent,
  InformationsClientEditModeComponent,
  LegalNoticesComponent,
  CaracteristiquesComponent,
  CaracteristiquesReadModeComponent,
  CaracteristiqueComponent,
  ExpertImmobilierComponent,
  ExpertImmobilierReadModeComponent,
  ExpertImmobilierEditModeComponent,
  CaracteristiquesEditModeComponent,
  BienAgricoleFormComponent,
  AppartementFormComponent,
  GarageFormComponent,
  ImmeubleFormComponent,
  MaisonFormComponent,
  TerrainFormComponent,
  BienViticoleFormComponent,
  LocalActiviteFormComponent,
  NotreOrganismeComponent,
  NotreOrganismeReadModeComponent,
  NotreOrganismeEditModeComponent,
  InformationsBienComponent,
  InformationsBienReadModeComponent,
  InformationsBienEditModeComponent,
  PhotographiesComponent,
  PhotographiesEditModeComponent,
  PhotographiesReadModeComponent,
  DetailsDossierComponent,
  DetailsDossierReadModeComponent,
  DetailsDossierEditModeComponent,
  TendanceMarcheImmobilierComponent,
  TendanceMarcheImmobilierEditModeComponent,
  TendanceMarcheImmobilierReadModeComponent,
  InformationsGeneralesComponent,
  ValeurEstimeeSansPlusOuMoinsValuesComponent,
  CartographieComponent,
  HelpSearchComponent,
  StatsImage,
  PreContractStats,
  StatsActionsComponent,
  CadastreComponent,
  CadastreReadModeComponent,
  CadastreEditModeComponent,
  AddressComponent,
  AddressEditModeComponent,
  AddressReadModeComponent,
  ArrayFieldGetterPipe,
  StatistiquesComponent,
  LandingPageComponent,
  HeaderComponent,
  HeroSectionComponent,
  HeroSectionBoxComponent,
  DescriptionSectionComponent,
  ServicesSectionComponent,
  CardComponent,
  KeyFiguresComponent,
  ToolsSectionComponent,
  FooterComponent,
  ContactSectionComponent,
  BurgerMenuComponent,
  PrivacyPolicyComponent,
  SafePipe,
  NotesComponent,
  NotesReadModeComponent,
  NotesEditModeComponent,
];

@NgModule({
  declarations: DECLARED,
  imports: [
    FeatureFlagDirective,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    DesignSystemModule,
    AdminLayout,
    RouterModule,
    CropperjsPictureEditorComponent,
    LesMoinsComponent,
    LesPlusComponent,
    SectionComponent,
    DefinitionsComponent,
  ],
  exports: [
    ...DECLARED,
    LesPlusComponent,
    LesMoinsComponent,
    SectionComponent,
    DefinitionsComponent,
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'fr-FR' }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LegacyAppModule {}
